export const REF_NAME = 'EXPENSESTYPE';
export const REF_PATH = 'expensestype';
export const NAME = 'Expenses type';
